import { type FC } from 'react';

import { Text } from '../Typography';
import {
  headingStyles,
  markerStyles,
  rootStyles,
} from './NumberedSection.styles';
import { type NumberedSectionProps } from './NumberedSection.types';

/**
 * A bordered card with a numbered heading. Use it to group one step of a
 * checkout, such as plan selection or payment.
 */
const NumberedSection: FC<NumberedSectionProps> = ({
  step,
  title,
  children,
  className,
  ...rest
}) => {
  return (
    <section {...rest} className={className} css={rootStyles}>
      <Text as="h2" css={headingStyles} fontWeight="bold" size="md">
        <span aria-hidden="true" css={markerStyles}>
          <Text
            as="span"
            color="var(--color-base-white)"
            fontWeight="bold"
            size="xs"
          >
            {step}
          </Text>
        </span>
        {title}
      </Text>
      {children}
    </section>
  );
};

NumberedSection.displayName = 'NumberedSection';

export default NumberedSection;
